import React from "react";

import TextField from "@material-ui/core/TextField";

import useStyles from "../styles/textFieldStyle";

const CstmTextField = (props) => {
  const { form, field } = props;

  const classes = useStyles();

  let otherProps = {};

  if (form.errors[field.name] && form.touched[field.name]) {
    otherProps.helperText = form.errors[field.name];
    otherProps.error = true;
  }

  return (
    <TextField
      variant="outlined"
      onChange={(e) => {
        form.setFieldValue(field.name, e.target.value);
      }}
      {...props}
      value={field.value}
      className={[classes.width100, classes.root]}
      {...otherProps}
      {...props.formControlStyle}
    />
  );
};

export default CstmTextField;



// WEBPACK FOOTER //
// ./src/components/CstmTextField.js